import { Box, type IColumn, Typography } from 'shared/ui'
import { AudioPlayer } from 'shared/ui/AudioPlayer'
import { type DropsRow } from 'entities/Call/model/DropsRow'

export const columns = (): IColumn<DropsRow>[] => [
  {
    field: 'label',
    name: 'Name',
    width: '195px',
    maxWidth: 195,
    renderRowCell: (row) => {
      return (
        <Typography
          ellipsis
          tag='div'
          variant={'body-md-regular'}
          ariaLabel='VoicemailDropName'
          tooltipProps={{ label: row.name }}
        >
          {row.name}
        </Typography>
      )
    },
  },
  {
    field: 'audio',
    name: 'Audio',
    renderRowCell: (row) => {
      return (
        <Box paddingTop={'12px'} paddingBottom={'12px'}>
          <AudioPlayer url={row.url} fullWidth hidePlayerActions={true} colorType={'gray'} />
        </Box>
      )
    },
  },
]
